import styled from 'styled-components'
import { devices } from '../../../utils/screen_sizes'
import { Card } from '@material-ui/core'

import { solidBlack } from '../../../utils/colors'

export const StyledSection = styled.section`
    .swiper-container {
        @media${devices.mobileS} {
            margin-top: 0rem;
        }

        @media${devices.laptop} {
            margin-top: 3rem;
        }
    }
    .swiper-slide img {
        width: 100%;
        object-fit: cover;
    }
    .smooth-image-wrapper {
    }
    .swiper-pagination {
        display: none;
    }
    .swiper-pagination-bullet-active {
        opacity: 1;
        background: #58cab9;
    }

    @media${devices.tablet} {
        height: 200px;
        .swiper-slide img {
        }
    }

    @media${devices.tabletL} {
    }

    @media ${devices.laptop} {
        height: 340px;
        .swiper-pagination {
            display: block;
        }
        .swiper-slide img {
        }

        .smooth-image-wrapper {
            min-height: calc(100vw / 6);
        }
    }
`
export const StyledCard = styled(Card)`
    margin: -1.6rem auto auto auto;
    left: 0;
    right: 0;
    padding: 1rem;
    width: 18rem;
    position: absolute;
    z-index: 1;
    color: ${solidBlack};
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.06),
        0px 1px 1px 0px rgba(0, 0, 0, 0.042),
        0px 1px 3px 0px rgba(0, 0, 0, 0.036);

    button {
        width: 100%;
        /* color: #eee !important; */
    }
    .swiper-button-next {
        color: #fff;
    }
    .swiper-button-prev {
        background-color: #fff;
    }

    &:hover {
    }

    @media ${devices.mobileM} {
        width: 20rem;
    }

    @media ${devices.tablet} {
        padding: 1rem 2rem 2rem;
        .input-select {
        }
    }
    @media ${devices.tabletL} {
    }
    @media ${devices.laptop} {
        margin: -7rem 0 0 6rem;
        .input-select {
        }
    }
    @media ${devices.desktop} {
        margin: -7rem 0 0 6rem;
        .input-select {
        }
    }
`

export const StyledRegisterCardWrapper = styled(Card)`
    width: 95%;
    max-width: 1142px;
    margin: 0 auto;
    position: relative;
    margin: -7rem auto 7em auto;

    @media ${devices.mobileS} {
        margin: 2rem auto 2rem auto;
    }
    @media ${devices.mobileM} {
        margin: 2rem auto 2rem auto;
    }

    @media ${devices.laptop} {
        margin: -7rem auto 7em auto;
    }
    @media ${devices.tablet} {
        margin: 0rem auto 7em auto;
    }
`
export const StyledRegisterCard = styled(Card)`
    color: ${solidBlack};
    box-shadow: 0.125rem 0.25rem rgba(0, 0, 0, 0.075);

    /* box-shadow: 1px 1px 9px -1px rgba(0, 0, 0, 0.1); */

    button {
        width: 100%;
        color: #eee !important;
    }
    .swiper-button-next {
        color: #fff;
    }
    .swiper-button-prev {
        background-color: #fff;
    }

    &:hover {
    }

    @media ${devices.mobileM} {
        /* width: 20rem; */
    }

    @media ${devices.tablet} {
        padding: 2rem;
        .input-select {
        }
    }
    @media ${devices.tabletL} {
    }
    @media ${devices.laptop} {
        /* margin: -8rem 0 0 6rem;
        .input-select {
        } */
    }
    @media ${devices.desktop} {
        /* margin: -8rem 0 0 6rem;
        .input-select {
        } */
    }
`

export const StyledHeroBackground = styled.div`
    @media ${devices.tablet} {
        height: 320px;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #fff;
        background-image: url('/assets/images/hero/Buyback-banner.png');
    }
`

export const StyledMobileSlider = styled.div`
    @media ${devices.tablet} {
        display: none;
    }
`

export const StyledSlide = styled.div`
    display: flex;
    justify-content: center;

    .smooth-image-wrapper {
        width: 100%;
    }

    a {
        position: absolute;
        z-index: 1;
        color: #fff;
        bottom: 2em;
        left: 4em;
        font-size: 0.8rem;
    }

    @media ${devices.mobileL} {
        a {
            font-size: 1rem;
        }
    }
    @media ${devices.tablet} {
        a {
            font-size: 1rem;
            left: 8em;
        }
    }
    @media ${devices.laptop} {
        a {
            left: unset;
            bottom: 4em;
        }
    }
    @media ${devices.desktop} {
        a {
            left: unset;
            bottom: 5em;
        }
    }
`
